import _ from 'lodash';
import { Reducer } from 'redux';
import ContentConstants from '../contentConstants';
import { ICustomQuestion } from '../models';
import * as api from '../services/CustomQuestionAPI';
import * as Actions from './Actions';
import { ActionTypes } from './ActionTypes';

export interface ICustomQuestionListState {
	loading: boolean;
	questions: ICustomQuestion[];
}

export const defaultState: ICustomQuestionListState = {
	loading: false,
	questions: [],
};

export const ActionCreators = {
	GetCustomQuestions: (surveyId: number, cultureCode: string, isDemographic: boolean) => (dispatch: any) => {
		dispatch({ type: ActionTypes.CUSTOM_QUESTIONS_GET_REQUESTED });

		return api
			.getCustomQuestions(surveyId, cultureCode, isDemographic)
			.then((questions: ICustomQuestion[]) => dispatch({ type: ActionTypes.CUSTOM_QUESTIONS_GET_SUCCEEDED, payload: questions }))
			.catch(() => dispatch({ type: ActionTypes.CUSTOM_QUESTIONS_GET_FAILED }));
	},
	SelectQuestion: (question: ICustomQuestion, isSelected: boolean, parentQuestionId?: number) => (dispatch: any) => {
		dispatch({ type: ActionTypes.CUSTOM_QUESTION_SELECTED, payload: { question, isSelected, parentQuestionId } });
		if (isSelected) {
			dispatch({ type: ActionTypes.TOAST_INFO_NOTIFICATION, payload: ContentConstants.TOAST_QUESTIONMODAL_ADDED });
			if (question.isDemographic) {
				dispatch({
					type: ActionTypes.CLIENT_PARTICIPANT_ATTRIBUTE_ADD_SELECTED_BYCOLUMN,
					payload: question.externalAttributeColumnName,
				});
			}
		} else {
			dispatch({ type: ActionTypes.TOAST_INFO_NOTIFICATION, payload: ContentConstants.TOAST_QUESTIONMODAL_REMOVED });
			if (question.isDemographic) {
				dispatch({
					type: ActionTypes.CLIENT_PARTICIPANT_ATTRIBUTE_REMOVE_SELECTED_BYCOLUMN,
					payload: question.externalAttributeColumnName,
				});
			}
		}
	},
};

type KnownActions =
	| Actions.ICustomQuestionsGetRequested
	| Actions.ICustomQuestionsGetSucceeded
	| Actions.ICustomQuestionsGetFailed
	| Actions.ICustomQuestionSaveSucceeded;

export const reducer: Reducer<ICustomQuestionListState, KnownActions> = (
	state: ICustomQuestionListState | undefined,
	action: KnownActions,
): ICustomQuestionListState => {
	if (!state) {
		state = { ...defaultState };
	}

	switch (action.type) {
		case ActionTypes.CUSTOM_QUESTIONS_GET_REQUESTED:
			return { ...state, loading: true };

		case ActionTypes.CUSTOM_QUESTIONS_GET_FAILED:
			return { ...state, loading: false };

		case ActionTypes.CUSTOM_QUESTIONS_GET_SUCCEEDED: {
			const orderedCustomQuestions = _.orderBy(action.payload, 'questionId', 'desc');
			return { ...state, loading: false, questions: orderedCustomQuestions };
		}
	}

	return state;
};
